module.exports = __webpack_public_path__ + "app/components/kiss-label-31kyAJuK.html";